import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.AccountReceivable.ImportFromExcel.IRequest;
type Response = Api.Finance.AccountReceivable.ImportFromExcel.IResponse;
type Headers = Api.Finance.AccountReceivable.ImportFromExcel.IHeaders;
const url = '/api/Finance/AccountReceivable/ImportFromExcel';
export default async function accountReceivableImportFromExcelApi(request: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    body: request,
    method: HttpMethod.post,
    url: createPathFromRoute(url),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
